import { useCallback, useEffect } from 'react'

export const useGtmScript = (id: string | undefined, nonce: string, isEnabled: boolean): void => {
  const gtmScript = useCallback(() => {
    const gtmScriptElement = document.createElement('script')

    if (id && isEnabled) {
      gtmScriptElement.nonce = nonce
      gtmScriptElement.innerText = `;(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src='https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);})(window,document,'script','dataLayer', '${id}');`
      document.head.appendChild(gtmScriptElement)
    }

    return () => {
      try {
        document.head.removeChild(gtmScriptElement)
        // eslint-disable-next-line no-empty
      } catch {}
    }
  }, [id, nonce, isEnabled])

  useEffect(() => {
    gtmScript()
  }, [gtmScript])
}
